"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const layers_1 = require("../../../services/layers");
const constants_1 = require("./constants");
const createEditableTextLayer_1 = __importDefault(require("./createEditableTextLayer"));
const helpers_1 = require("./helpers");
const addCustomEditableTextLayer = (existingTextLayers, currentDesignId, currentPrintable, activePage, maxZIndex) => {
  let startingX = constants_1.DEFAULT_POSITION_X;
  let layerWidth = constants_1.DEFAULT_SIZE_WIDTH;
  if (currentPrintable.isCompositeDesign) {
    layerWidth = layerWidth / 2;
    startingX = startingX / 2 + (activePage === layers_1.CoverageType.LEFT ? 0 : 0.5);
  }
  const {
    newX,
    newY
  } = (0, helpers_1.findFirstAvailableSlot)(existingTextLayers, startingX);
  const newEditableTextLayerData = {
    designId: currentDesignId,
    x: newX,
    y: newY,
    width: layerWidth,
    height: constants_1.DEFAULT_SIZE_HEIGHT,
    zIndex: maxZIndex,
    isCompositeDesign: !!currentPrintable.isCompositeDesign,
    activePage,
    existingTextLayers
  };
  const newEditableTextLayer = (0, createEditableTextLayer_1.default)(newEditableTextLayerData);
  return newEditableTextLayer;
};
exports.default = addCustomEditableTextLayer;